import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { IconCompose } from '../components/talkAppleIcons';
import { PersonAvatar, PeopleHeader, SearchField, PeopleEmpty, PeopleLoading, usePeopleScroll } from '../components/PeopleUI';

export function messageTime(value) {
  if (!value) return '';
  const date = new Date(value.includes('T') ? value : `${value.replace(' ', 'T')}Z`);
  if (Number.isNaN(date.getTime())) return '';
  const today = new Date();
  return date.toDateString() === today.toDateString()
    ? date.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' })
    : date.toLocaleDateString('ja-JP', { month: 'numeric', day: 'numeric' });
}

export default function Chat() {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  const [params, setParams] = useSearchParams();
  const query = params.get('q') || '';
  const unreadOnly = params.get('view') === 'unread';
  usePeopleScroll(`chat:${params.toString()}`, !loading);
  useEffect(() => {
    let active = true;
    setLoading(true); setError('');
    axios.get('/api/contacts').then(({ data }) => { if (active) setConversations(data); })
      .catch(() => { if (active) setError('チャットを読み込めませんでした。'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [retry]);
  const update = (key, value) => setParams(previous => { const next = new URLSearchParams(previous); value ? next.set(key, value) : next.delete(key); return next; }, { replace: true });
  const unreadCount = conversations.filter(conv => conv.unread_count > 0).length;
  const visible = conversations.filter(conv => (!unreadOnly || conv.unread_count > 0) && `${conv.username} ${conv.last_message || ''}`.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase()));

  return <main className="jt-screen jt-chat-screen">
    <PeopleHeader title="チャット"><Link data-control="icon" data-control-id="Chat-jt-icon-link" to="/search" className="jt-icon-link" aria-label="話す相手を探す"><IconCompose size={21} /></Link></PeopleHeader>
    <div className="jt-toolbar">
      <SearchField value={query} onChange={value => update('q', value)} placeholder="名前やメッセージで検索" />
      <div className="jt-tabs" aria-label="チャット一覧の切り替え">
        <button data-control="tab" data-control-id="Chat-tab" aria-pressed={!unreadOnly} onClick={() => update('view', '')}>すべて</button>
        <button data-control="tab" data-control-id="Chat-tab" aria-pressed={unreadOnly} onClick={() => update('view', 'unread')}>未読{unreadCount > 0 && <span>{unreadCount}</span>}</button>
      </div>
    </div>
    {loading ? <PeopleLoading /> : error ? <PeopleEmpty title={error} description="接続を確認して、もう一度お試しください。" onRetry={() => setRetry(value => value + 1)} /> : visible.length > 0 ? visible.map(conv => <Link data-control="row" data-control-id="Chat-jt-chat-row" key={conv.partner_id} to={`/chat/${conv.partner_id}`} className={`jt-chat-row${conv.unread_count > 0 ? ' is-unread' : ''}`}>
      <PersonAvatar person={conv} />
      <div className="jt-person-copy">
        <div className="jt-chat-top"><span className="jt-person-name">{conv.username}</span><time>{messageTime(conv.last_at)}</time></div>
        <div className="jt-chat-bottom"><p>{conv.last_type === 'audio' ? '音声メッセージ' : conv.last_type === 'image' ? '写真' : conv.last_message || '最初のメッセージを送る'}</p>{conv.unread_count > 0 && <span className="jt-unread" aria-label={`未読${conv.unread_count}件`}>{conv.unread_count > 99 ? '99+' : conv.unread_count}</span>}</div>
      </div>
    </Link>) : <PeopleEmpty title={query ? 'チャットが見つかりません' : unreadOnly ? '未読のメッセージはありません' : '会話をはじめよう'} description={query ? '別の名前やキーワードで試してみてください。' : unreadOnly ? '届いたメッセージをすべて確認しました。' : '気になる相手のプロフィールから、メッセージを送れます。'} to={!query && !unreadOnly ? '/search' : undefined} action="相手を探す" />}
  </main>;
}
